//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from "vuex";
import { inventory, api_SaveClientSeed, api_OpenCaseLog, api_GetSeeds, api_RegenerateAndGetCurrentServerSeed } from "@/api";
import { conversion, imgfilter } from "@/tool";

export default {
    name: "caseHistory",
    data() {
        return {
            historyData: {
                data: { list: [], total: 0 },
                current: 1,
                size: 15,
            },
            clientSeed: "",
            serverSeedHash: "",
            serverSeed: "",
            savingSeed: false,
            regeneratingSeed: false,
        };
    },
    computed: {
        ...mapState(["user"]),
    },
    methods: {
        ...mapMutations(["setInfo"]),
        async getSeeds() {
            try {
                const res = await api_GetSeeds();
                if (res.data.code === 0) {
                    const data = res.data.data;
                    if (data) {
                        this.clientSeed = data.clientHashSeed || "";
                        this.serverSeedHash = data.serverHash || "";
                    }
                }
            } catch (e) {
                console.error("Failed to fetch seeds:", e);
            }
        },
        async regenerateServerSeed() {
            this.regeneratingSeed = true;
            try {
                const res = await api_RegenerateAndGetCurrentServerSeed();
                if (res.data.code === 0) {
                    const data = res.data.data;
                    if (data && data.originalServerSeed) {
                        this.serverSeed = data.originalServerSeed;
                        this.$toast.success("获取成功，服务器种子已更新");
                        this.getSeeds();
                    } else {
                        this.$toast.error("获取服务器种子失败: 返回数据为空");
                    }
                } else {
                    this.$toast.error(res.data.msg || "获取服务器种子失败");
                }
            } catch (e) {
                this.$toast.error("网络错误");
                console.error(e);
            } finally {
                this.regeneratingSeed = false;
            }
        },
        openThirdPartyVerify() {
            window.open("https://sharplab.io/#v2:C4LgTgrgdgNAJiA1AHwAICYCMBYAUKgBgAJVMA6AZQFMBjCMAS2AE8yBhMZgB2AHsBzMAEMuAC2YBuPIRLkAKlQAewKbmmZiAZypgAbjupU4RALxEAROYkB6a4GsNQJmKgWHNAhUqALNUCznoAVtdcRoAbBiooYENjM0sbewdAIu1AdiNAe69vXyJgBgBbKk1gIXSuUwsrIlsiRzTM7NyuPAYQ1N4c/wAlISh+KgKAWkwJYutSh0BG7y9AELdAAHNAck0wXn9/QB4FPBqAMwAKbT0DKiMTE0tkZACgkLCdveRyrJy80/N9vkaWtqoAHhMCAEo8AG88Ij/ZACcK3MgHfoxyAGO1AC6mgCHlQAOpuZ3qp/iQAOyqAC+eF0QjARHW+jAYQAEkJNKICmxeHkIMAqBRREJ0ABWABsJLJax0BLCiMW+A0RBoVIARrUjBRgIw2gUACTmL74zZGdmidGdL6HYKhLZwNVfC6VPLoqwpBlkilUrg0ukM5ls0miFZC9KiqDiyW1fi8tT84hm0QABTAVCWDEUBX9lAgwtIBBWBBgRAAHN6ILVgER/QA1IT+CAdMyUqAE4BkOS8ACqAEkQgBmdArf1BkNhxOYFnevBwXjR/wdKC8MDpXMMABeRhzeYLRBW3d7VHe2dz+eKRDTITIAFkhIpJ/nVDU6sHNBB/BmzCt0+9t8BRGQAGL+XiDlYDocj8dwPcdABU9QerTtO8RCIEQPR8gwSwzsep4Zs8YHATBZ4FOBuCQdBWSwUQAB8/65o8QFEEh554c0gFUAe/JAuYgDLfoAOeaAPRmgBY/+YiDEZ2PqkCysjEJS1K0vSjKsiqKyxkQtRWsAny4D8uDIjIKwUESACCdp4rarIFEpqmsuwwZCLSKzvNJyKyciyLCswtIANoALpEJZtIACIGUIBQAKJQEKcCemQFZyPeSZkAA4lQwAAEJWVkl5QJJ3rmf8jlUHZRGYchZhkkJLLsJa1oiUlLk5PFCWokQ4VMEWJY6GWvASlK/ArOxZBNFQXD+EINBUMCnTmImljvDVAAyvAAO46EZSL/JiuDokAA==", "_blank");
        },
        async saveClientSeed() {
            if (!this.clientSeed) {
                this.$toast.error("请输入客户端种子");
                return;
            }
            this.savingSeed = true;
            try {
                const res = await api_SaveClientSeed({ clientSeed: this.clientSeed });
                if (res.data.code === 0) {
                    this.$toast.success("保存成功");
                    this.setInfo();
                    this.getSeeds();
                } else {
                    this.$toast.error(res.data.msg || "保存失败");
                }
            } catch (e) {
                this.$toast.error("网络错误");
            } finally {
                this.savingSeed = false;
            }
        },
        getHistory(obj) {
            api_OpenCaseLog({ page: obj.current, size: obj.size }).then((res) => {
                if (res.data.code === 0) {
                    this.historyData.data.list = res.data.data.data || [];
                    this.historyData.data.total = res.data.data.totalItems || 0;
                }
            });
        },
        pageF(v) {
            this.getHistory({ current: v, size: this.historyData.size });
        },
        getAwardName(fullname) {
            if (!fullname) return '';
            const match = fullname.match(/^(.*?)\s?(\(.*\))?$/);
            return match ? match[1] : fullname;
        },
        getAwardSubName(fullname) {
            if (!fullname) return '';
            const match = fullname.match(/^(.*?)\s?(\(.*\))?$/);
            return match ? match[2] : '';
        }
    },
    filters: {
        conversion,
        imgfilter,
    },
    created() {
        this.getHistory({
            current: this.historyData.current,
            size: this.historyData.size,
        });
        this.getSeeds();
    },
};
